import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import * as constants from '../../../constants/constants';
import { SortableColumn } from './SortableColumn/SortableColumn.jsx';

const TableHeaderComponent = (props) => {
  const { optionsStore, labelsStore } = props;

  const deliveryColumn = optionsStore.isDeliveryDisplay && (
    <SortableColumn
      text={labelsStore.deliveryDaysHeadLabel}
      tooltipText={labelsStore.expectedDeliveryDaysLabel}
      classNames="cart-table__column cart-table__column--small"
      name={constants.sortBy.deliveryDate}
    />
  );

  const subtotalTooltip = !optionsStore.isWeeePricesVisible && optionsStore.isLegalTextEnabled
    && labelsStore.priceTaxLabel;
  const subtotalColumn = optionsStore.isPriceEnabledOnSite && (
    <SortableColumn
      text={labelsStore.giftlistTableSubtotal}
      tooltipText={subtotalTooltip}
      classNames="cart-table__column cart-table__column--small"
      name={constants.sortBy.subtotal}
    />
  );

  return (
    <div className="cart-table__header cart-table__row">

      <SortableColumn
        text={labelsStore.giftlistTableName}
        classNames="cart-table__column cart-table__column--wide"
        name={constants.sortBy.skuID}
      />

      {deliveryColumn}

      <SortableColumn
        text={labelsStore.giftlistTableQty}
        classNames="cart-table__column cart-table__column--small"
        name={constants.sortBy.quantity}
      />

      {subtotalColumn}

      {optionsStore.isWeeePricesVisible && (
        <div className="cart-table__column cart-table__column--weee-prices cart-table__header-cell" />
      )}
      <div className="cart-table__column cart-table__column--delete cart-table__header-cell" />

    </div>
  );
};

TableHeaderComponent.propTypes = {
  labelsStore: propTypes.shape({
    giftlistTableSubtotal: propTypes.string,
    deliveryDaysHeadLabel: propTypes.string,
    priceTaxLabel: propTypes.string,
    giftlistTableName: propTypes.string,
    giftlistTableQty: propTypes.string,
    expectedDeliveryDaysLabel: propTypes.string,
    daysLabel: propTypes.string
  }).isRequired,
  optionsStore: propTypes.shape({
    isDeliveryDisplay: propTypes.bool,
    isPriceEnabledOnSite: propTypes.bool,
    isLegalTextEnabled: propTypes.bool,
    isWeeePricesVisible: propTypes.bool
  }).isRequired
};

export const TableHeader = inject('optionsStore', 'labelsStore')(observer(TableHeaderComponent));
